import { getAugmentedNamespace } from './_commonjsHelpers.js';
import * as index from '../node_modules/react-popper/lib/esm/index.js';

var require$$60 = /*@__PURE__*/getAugmentedNamespace(index);

export { require$$60 as default };
